// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"162":"f1fa82aea7e9ba1a510e","740":"e56bc63051c4312f56c0"}[chunkId] + ".js";
};